module.exports = __webpack_public_path__ + "img/free.f553eb71.jpg";